import React from "react";

type FloatingToastProps = {
  message: string | null;
  tone: "success" | "error";
  onClear: () => void;
  durationMs?: number;
};

export function FloatingToast({ message, tone, onClear, durationMs = 5000 }: FloatingToastProps) {
  const [isLeaving, setIsLeaving] = React.useState(false);

  React.useEffect(() => {
    if (!message) return;
    setIsLeaving(false);

    const leaveDelay = Math.max(0, durationMs - 500);
    const leaveTimer = window.setTimeout(() => setIsLeaving(true), leaveDelay);
    const clearTimer = window.setTimeout(() => onClear(), durationMs);

    return () => {
      window.clearTimeout(leaveTimer);
      window.clearTimeout(clearTimer);
    };
  }, [message, durationMs, onClear]);

  if (!message) return null;

  return (
    <div className={`floating-toast floating-toast--${tone}${isLeaving ? " is-leaving" : ""}`} role="status" aria-live="polite">
      <span>{message}</span>
      <button type="button" className="floating-toast-close" onClick={onClear} aria-label="Cerrar aviso">
        ×
      </button>
    </div>
  );
}
